import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { Gallery } from './gallery';
import { ImageLoaderModule } from '../image-loader/image-loader.module';

export { GalleryOptions } from './gallery';


export class GalleryModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: GalleryModule, providers: []
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    ImageLoaderModule.forRoot()
  ],
  exports: [
    Gallery
  ],
  declarations: [
    Gallery
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
